export const ACTIONS = {
  BOOK: "book",
  ENQUIRY_MESSAGE: "enquiry",
  FAST_TRACK_INFORMATION: "fast-track-information",
  NONE: "",
};

export const SUPPORTED_TRANSLATION_LANGUAGES = ["es", "en"];
